import { BaseLine } from 'src/app/features/setup/models/base-line';

export class Global {

}

export class TypeBaseineSimulation {
    type: number;
    typeId: number;
    tenantId: number;
    userEmail: string;
    userName: string;
    userId: string;
    simulationId: number;
    simulationName: string;
    simulationYear: number;
    baselineId: number;
    baselineName: string;
    baselineYear: number;
    isReadOnly: boolean;
    currency: string;
    precision: number;
    isLocked: boolean;
}
